import { Fab, SvgIcon, Tooltip, Typography } from "@mui/material";
import { ReactComponent as IconEmailFast } from "../../../images/email-fast.svg";
import { useAppStore } from "../../store/app";
import { useCheckoutData } from "../../hooks/use-checkout-data";
import useXHR from "../../hooks/use-xhr";
import l10n from "../../lib/l10n";
import { ACTION_EMAIL_PREVIEW, CROPPER_META_KEY, wp_ajax_hook } from "../../../var";
import { addToast } from "../toast";

function EmailPreviewTool() {
  const app = useAppStore();
  const checkoutData = useCheckoutData();
  const xhr = useXHR();

  if (!l10n?.u_billing_email || l10n?.u_billing_email?.trim() === "") {
    return null;
  }

  const onClick = async () => {
    app.setBlocked();

    try {
      const data = checkoutData.get(wp_ajax_hook[ACTION_EMAIL_PREVIEW], l10n.wc_nonce);
      const response = await xhr.post(data);
      
      console.log('->', response.data);

      if (response?.status !== 200 || ! response?.data?.success) {
        throw new Error('Email error');
      }
      addToast(<Typography>{l10n.ui_label_email_preview_success}</Typography>, { $type: "info" });
    } catch (e) {
      console.log('error', e);
      addToast(<Typography>{l10n.ui_label_email_preview_error}</Typography>, { $type: "error" });
    }

    app.setActive();
  };

  return (
    <Tooltip title={l10n.ui_label_email_preview_text} placement="top">
      <Fab onClick={onClick}>
        <SvgIcon component={IconEmailFast} />
      </Fab>
    </Tooltip>
  );
};

export default EmailPreviewTool;